import Axios from "@/plugins/Axios";
// import store from "@/store";
import RecursosHumanos from "@/Models/RecursosHumanos";

export class RecursosHumanosService {
  async syncAll() {
    const response = await Axios().get("users");
    const usuarios = response.data.map((usuario) => new RecursosHumanos(usuario));
    return usuarios;
  }

  async gerarRelatorioDossie(usuario_id, rh_id) {
    const response = await Axios()
      .get(`relatorios/relatorioDossie/${usuario_id}/${rh_id}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `relatorio_dossie.pdf`;
        link.click();
      });
    return response;
  }

  async uploadDocumentos(formData, usuarioId) {
    Axios().interceptors.request.use((config) => {
      config.headers["Content-Type"] = "multipart/form-data";
      return config;
    });
    const response = await Axios().post(
      `/recursos-humanos/upload-documento/${usuarioId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response;
  }

  async uploadFoto(formData, usuarioId) {
    const response = await Axios().post(`/recursos-humanos/upload-foto/${usuarioId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  }

  async downloadDocumento(usuarioId, file) {
    const response = await Axios()
      .get(`recursos-humanos/download-documento/${usuarioId}/${file}`, {
        responseType: "blob",
      })
      .then((response) => {
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(response.data);
        window.open(a.href);
      });

    return response;
  }

  async syncAllPaginate(pageNumber, query = "") {
    const response = await Axios().get(`users/paginate?page=${pageNumber}&query=${query}`);
    // const usuarios = response.data.data.map((usuario) => new Usuario(usuario));
    return response;
  }

  async getUsuario(usuario_id) {
    const response = await Axios().get(`recursos-humanos/user/${usuario_id}`);
    return response.data;
  }

  async getUsuarioRecursosHumanos(usuario_id) {
    const response = await Axios().get(`recursos-humanos/${usuario_id}`);
    return response.data;
  }

  async criarRecursosHumanos(usuario) {
    const response = await Axios().post("recursos-humanos", usuario);
    const novaUsuario = response.data;
    return novaUsuario;
  }

  async removerProfissional(id) {
    const response = await Axios().delete(`recursos-humanos/profissionais/${id}`);
    return response.data;
  }

  async removerFormacao(id) {
    const response = await Axios().delete(`recursos-humanos/formacoes/${id}`);
    return response.data;
  }

  async pegarMatriculaItem(usuario_id) {
    const response = await Axios().get(`recursos-humanos/matricula-item/${usuario_id}`);
    return response.data;
  }

  async atualizarUsuarioRecursosHumanos(usuario) {
    const response = await Axios().put(`recursos-humanos/${usuario.id}`, usuario);
    const usuarioAtualizada = response.data;
    return usuarioAtualizada;
  }

  async deletarUsuario(usuario) {
    const response = await Axios().delete(`users/${usuario.id}`);
    const usuarioDeletada = response.data;
    return usuarioDeletada;
  }

  async recuperarUsuario(usuario) {
    return this.atualizarUsuario({ ...usuario, deleted_at: null });
  }

  async atualizarSituacao(usuario, novaSituacao) {
    const response = await Axios().put(`users/${usuario}/atualizarSituacao`, {
      ...usuario,
      situacao: novaSituacao,
    });
    const aulaAtualizada = response.data;
    return new Usuario(aulaAtualizada);
  }

  async atualizarDataBloqueio(usuario, dataBloqueio) {
    const response = await Axios().put(`users/${usuario}/atualizar-data-bloqueio`, {
      ...usuario,
      data_bloqueio: dataBloqueio || null,
    });
    const aulaAtualizada = { ...response.data, data_bloqueio: dataBloqueio };
    return new Usuario(aulaAtualizada);
  }

  // Métodos de Gestão de Escalas
  async getEscalas(userId) {
    const response = await Axios().get(`recursos-humanos/${userId}/escalas`);
    return response.data;
  }

  async salvarEscala(userId, escala) {
    const response = await Axios().post(`recursos-humanos/${userId}/escalas`, escala);
    return response.data;
  }

  async atualizarEscala(userId, escalaId, escala) {
    const response = await Axios().put(`recursos-humanos/${userId}/escalas/${escalaId}`, escala);
    return response.data;
  }

  async deletarEscala(userId, escalaId) {
    const response = await Axios().delete(`recursos-humanos/${userId}/escalas/${escalaId}`);
    return response.data;
  }

  async getEscalasModelos() {
    const response = await Axios().get(`recursos-humanos/escalas-modelos`);
    return response.data;
  }

  async getCargos() {
    const response = await Axios().get(`recursos-humanos/cargos`);
    return response.data;
  }

  async criarCargo(nome) {
    const response = await Axios().post(`recursos-humanos/cargos`, { nome });
    return response.data;
  }

  async deletarCargo(id) {
    const response = await Axios().delete(`recursos-humanos/cargos/${id}`);
    return response.data;
  }
}
export default new RecursosHumanosService();
